/* @flow */
import * as React from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

type Props = {
  disabled?: boolean,
  label?: string,
  labelAfter?: boolean,
  small?: boolean,
  checked?: boolean,
  defaultChecked?: boolean,
  isIndeterminate?: boolean,
  onChange?: (checked: boolean) => mixed,
};

type State = {
  checked: boolean,
};

class Checkbox extends React.PureComponent<Props, State> {
  state = { checked: 'checked' in this.props ? !!this.props.checked : !!this.props.defaultChecked };

  componentDidUpdate(prevProps: Props) {
    if ('checked' in this.props) {
      this.setState({
        checked: !!this.props.checked,
      });
    }
  }

  _handleChange = (event: any) => {
    const checked = !!event.target.checked;
    if (!('checked' in this.props)) {
      this.setState({
        checked,
      });
    }
    if (this.props.onChange) {
      this.props.onChange(checked);
      // this.props.onChange({
      //   target: {
      //     ...this.props,
      //     checked,
      //   },
      //   stopPropagation() {
      //     event.stopPropagation();
      //   },
      //   preventDefault() {
      //     event.preventDefault();
      //   },
      //   nativeEvent: event.nativeEvent,
      // });
    }
  };

  render() {
    const {
      label,
      labelAfter = false,
      disabled = false,
      small = false,
      isIndeterminate = false,
      onChange,
      ...otherProps
    } = this.props;
    const { checked = false } = this.state;
    const boxStyle = isIndeterminate ? classNames(styles.box, styles.boxIndeterminate) : styles.box;
    return (
      <label className={small ? styles.containerSmall : styles.containerMedium}>
        {label && !labelAfter && (
          <p className={small ? styles.labelBeforeSmall : styles.labelBefore}>{label}</p>
        )}
        <input
          disabled={disabled}
          className={styles.input}
          type={'checkbox'}
          checked={checked}
          onChange={this._handleChange}
          {...otherProps}
        />
        <div className={boxStyle} />
        {label && labelAfter && (
          <p className={small ? styles.labelAfterSmall : styles.labelAfter}>{label}</p>
        )}
      </label>
    );
  }
}

export default Checkbox;
